import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import { P } from "styled-icons/fa-solid"

import { getTextLength, cutTextLimit } from "./jace"

// 크기
export const sizeState = atom({
  key: "sizeState",
  default: {
    appWidth: document.documentElement.clientWidth,
    appHeight: document.documentElement.clientHeight,
    appPage: 2,
    pageWidth: 540,
    pageItem: 6,
  },
})

// 기본 테마
export const themeState = atom({
  key: "themeState",
  default: {
    b0: "#eee",
    b1: "#ccc",
    b2: "#aaa",
    f2: "#555",
    f1: "#333",
    f0: "#111",
  },
})

// Data Object
export const userObjState = atom({
  key: "userObjState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
})

// pages Object
export const pagesNprofileState = selector({
  key: "pagesNprofileState",
  get: ({ get }) => {
    const user = get(userObjState)
    const pagesObj = user ? {
      pageOrder: user.pageOrder,
      page0: user.page0,
      page1: user.page1,
      page2: user.page2,
      page3: user.page3,
    } : null
    const profileObj = user ? {
      displayName: user.displayName,
      info: user.info,
      search: user.search,
      memos: user.memos,
      colors: user.colors,
    } : null
    const shortName = user ? (
      user.displayName.split(" ", 1)[0].length > 8
        ? cutTextLimit(user.displayName.split(" ", 1)[0], 6) + "⋯"
        : user.displayName.split(" ", 1)[0]
    ) : null

    return {
      pagesObj,
      profileObj,
      shortName
    }
  },
})

// 편집 중 Pages Object
export const updatedPagesObjState = atom({
  key: "updatedPagesObjState",
  default: null,
})

// pages Object 편집 중?
export const editModeState = atom({
  key: "editModeState",
  default: false,
})

// 수정하는 Mark 위치
export const editObjState = atom({
  key: "editObjState",
  default: null,
})

// 수정 된 Page Id
export const editedPagesState = atom({
  key: "editedPagesState",
  default: [],
})

// 편집 중 Pages Object
export const updatedProfileObjState = atom({
  key: "updatedProfileObjState",
  default: null,
})



// for C&P, copied Object
export const copiedMarksState = atom({
  key: "copiedMarksState",
  default: [],
})


export const listObjState = atom({
  key: "listObjState",
  default: null,
})

export const addModeState = atom({
  key: "addModeState",
  default: false,
})

export const updatedObjState = atom({
  key: "updatedObjState",
  default: null,
})
export const pagesObjState = atom({
  key: "pagesObjState",
  default: null,
})